import { useContext } from 'react'
import ClientContext from 'contexts/ClientContext'
import { useLocation } from 'react-router-dom'
import classNames from 'classnames'
import { isMobile } from 'helpers/styles'
import QuestionCircle from 'components/assets/icons/QuestionCircle'
import Link from 'components/common/Link/Link'
import Logo from 'components/common/Logo/Logo'
import style from './Header.module.scss'
import { isAuthRoute } from 'helpers/app'
import LanguageSelector from 'components/LanguageSelector/LanguageSelector'
import CoLabelSwitch from 'components/CoLabelSwitch/CoLabelSwitch'

const Header = ({ logo, className, darkBg, lightBg, styles, hideRightSide }) => {
  const { pathname } = useLocation()
  const { isColabelAllowed, color, colabelNeutralDark } = useContext(ClientContext)

  return (
    <header className={classNames(style.header, className)} style={styles}>
      {
        logo 
        ? logo
        : !isColabelAllowed
          ? <Logo
            styles={{
              fill: darkBg ? '#fff' : lightBg ? '#000093' : isMobile() ? '#000093' : '#fff',
            }}
          />
          : <CoLabelSwitch
              className={style.colabel}
              styles={!color && {
                control:{
                  border: '1px solid #FFF',
                  '&:hover': {
                    border: '1px solid #fff'
                  },
                },
                singleValue:{
                  color: "#FFF"
                }
              }}
            />
      }
      {!hideRightSide && <div className={style['right-corner']}>
        {!isAuthRoute(pathname) && (
          <>
            <Link
              className={classNames(style['icon-button'], darkBg && style['dark-bg'])}
              label={<QuestionCircle styles={{ fill: color ? colabelNeutralDark : darkBg ? '#fff' : '#0000c9' }} />}
              text='blog'
              to="https://www.get-owen.com/blog"
              target="_blank"
              rel="noopener noreferrer"
            />
          </>
        )}
        <LanguageSelector darkBg={isAuthRoute(pathname)} />
      </div>}
    </header>
  )
}

export default Header
